import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { PaginationTypes } from 'types/sharedResponse'
import { handleResponseErr } from 'utils/apiHelperUtils'
import { Candidate } from './actions'
import * as actions from './actions'

type InitialStateType = {
  candidates: Candidate[]
  pagination: PaginationTypes
  fetching: boolean
}

const initialState: InitialStateType = {
  candidates: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    next_page: 2,
    page: 1,
    total_pages: 0,
    total_entries: 0,
  },
  fetching: false,
}

export default function reducer(state = initialState, action: Action): InitialStateType {
  switch (action.type) {
    case actions.GET_EXISTING_CANDIDATES_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }

    case actions.GET_EXISTING_CANDIDATES_FULFILLED: {
      return {
        ...state,
        candidates:
          action?.payload?.data?.pagination.current_page === 1
            ? action?.payload?.data?.data?.candidates
            : [...state.candidates, ...action?.payload?.data?.data?.candidates],
        pagination: action?.payload?.data?.pagination,
        fetching: false,
      }
    }

    case actions.GET_EXISTING_CANDIDATES_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    }

    default:
      return state
  }
}
